<app-frame [frameSrc]="url" id="RETGS"></app-frame>
